export class SignatureApplicationType {
  public static readonly RC_DSGINATURE = 1;
  public static readonly SIGN_NOTIFICATION = 2;
  public static readonly PACKAGING = 3;
}
